import { render, staticRenderFns } from "./IbanShow.vue?vue&type=template&id=3a86a88b&scoped=true&"
import script from "./IbanShow.vue?vue&type=script&lang=js&"
export * from "./IbanShow.vue?vue&type=script&lang=js&"
import style0 from "./IbanShow.vue?vue&type=style&index=0&id=3a86a88b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a86a88b",
  null
  
)

export default component.exports